import StoreProvider from "@shared/StoreProvider";
import Header from "./Header";

const HeaderApp = () => (
  <StoreProvider>
    <Header />
  </StoreProvider>
);

export default HeaderApp;
